import { IDepositExtended } from 'views/types/typeTransaction';
import { $api } from './interceptor';
import { Paginated } from 'types/paginated';
import {
  EOrderStatus,
  EOrderType,
  ITransactionStatistics,
} from 'views/types/transactions';

type DepositsParams = {
  page?: number;
  limit?: number;
  search?: string;
  txType?: EOrderType;
  showOnlyBlocked?: boolean;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
  from?: Date;
  to?: Date;
};

const txsApi = () => {
  const getAllTransactions = async (params: DepositsParams = {}) => {
    const { data } = await $api.get<Paginated<IDepositExtended>>(
      '/api/orders/all-transactions',
      {
        params,
      }
    );
    return data;
  };

  const approveTransaction = async (id: string) => {
    await $api.post('api/orders/approve-deposit-order', {
      orderId: id,
    });
  };

  const rejectTransaction = async (id: string, refundAddress?: string) => {
    await $api.post('api/orders/reject-deposit-order', {
      orderId: id,
      refundAddress,
    });
  };

  const approveWithdraw = async (id: string) => {
    await $api.post('api/orders/approve-withdraw-order', {
      orderId: id,
    });
  };

  const rejectWithdraw = async (id: string) => {
    await $api.post('api/orders/reject-withdraw-order', {
      orderId: id,
    });
  };

  const getStatistics = async () => {
    const { data } = await $api.get<ITransactionStatistics>(
      'api/orders/statistics'
    );
    return data;
  };

  const setCustomStatus = async (
    orderId: string,
    customStatus: Exclude<EOrderStatus, EOrderStatus.ALL>
  ) => {
    await $api.post('api/orders/set-custom-status', {
      orderId,
      customStatus,
    });
  };

  return {
    getAllTransactions,
    approveTransaction,
    rejectTransaction,
    approveWithdraw,
    rejectWithdraw,
    getStatistics,
    setCustomStatus,
  };
};

export const txsService = txsApi();
